import { render, staticRenderFns } from "./LabelGenView.vue?vue&type=template&id=9d370b98"
import script from "./LabelGenView.vue?vue&type=script&lang=js"
export * from "./LabelGenView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d370b98')) {
      api.createRecord('9d370b98', component.options)
    } else {
      api.reload('9d370b98', component.options)
    }
    module.hot.accept("./LabelGenView.vue?vue&type=template&id=9d370b98", function () {
      api.rerender('9d370b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labelGen/LabelGenView.vue"
export default component.exports